import { Configure, Index, InstantSearch } from 'react-instantsearch';
import type { ISearchOverlayTitles } from '@/components/SearchOverlay/types';
import { SuggestionsIndex } from '@/components/Instantsearch/components/SuggestionsIndex';
import { useEffect, useState } from 'react';
import getSearchClient from 'server/repository/algolia/client';

interface RecipeSearchResultsProps {
  searchOverlayData?: ISearchOverlayTitles;
  slug: string;
}

const HITS_PER_PAGE_RECIPE = 12;

export const RecipeSearchResults = ({ searchOverlayData, slug }: RecipeSearchResultsProps) => {
  const [searchOverlayDataExtended, setSearchOverlayDataExtended] = useState(searchOverlayData);

  useEffect(() => {
    if (searchOverlayData && !searchOverlayDataExtended?.searchClient) {
      const algoliaClient = getSearchClient();
      setSearchOverlayDataExtended({
        ...searchOverlayData,
        searchClient: algoliaClient,
      });
    }
  }, [searchOverlayData]);

  if (!searchOverlayDataExtended?.searchClient || !searchOverlayDataExtended?.indices?.recipes) {
    return null;
  }

  return (
    <InstantSearch
      searchClient={searchOverlayDataExtended.searchClient}
      indexName={searchOverlayDataExtended.indices.recipes}
      stalledSearchDelay={200}
      future={{
        preserveSharedStateOnUnmount: true,
        persistHierarchicalRootCount: true,
      }}
      insights={true}
    >
      <Configure query={slug} hitsPerPage={HITS_PER_PAGE_RECIPE} />
      <Index indexName={searchOverlayDataExtended.indices.recipes}>
        <SuggestionsIndex
          searchValue={slug}
          objectType="RECIPES"
          searchData={{
            copy: searchOverlayDataExtended?.copy,
          }}
          indexName={searchOverlayDataExtended.indices.recipes}
          numberOfAlreadyViewedHitsBeforeThisIndex={0}
        />
      </Index>
    </InstantSearch>
  );
};
